/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'g_parking': {
    width: 16,
    height: 16,
    viewBox: '0 0 51.39 56.69',
    data: '<g _fill="#fff"><path pid="0" d="M28.35 53.11a24.77 24.77 0 1119.47-40.07l2.81-2.22a28.34 28.34 0 10.76 34l-2.91-2.09a24.83 24.83 0 01-20.13 10.38"/><path pid="1" d="M25.25 27.73h2.28c4 0 7.78-.8 7.78-5.72 0-3.76-3-5.1-6.71-5.1h-3.35zM20.47 43.2V13.38h8.46c5.94 0 11.35 1.92 11.35 8.58 0 6.93-5.36 9.35-11.67 9.35h-3.36V43.2z"/></g>'
  }
})
